import SelectBase from './Select';
export * from './Select';

export const Select = SelectBase;

export default Select;
